export const KeyIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
        >
            <g clip-path="url(#clip0_4713_444)">
                <path
                    d="M5.03384 0.5C3.42133 0.5 2.1094 1.81187 2.1094 3.42444V5.09466C2.1094 5.11364 2.08598 5.14562 2.06758 5.15173C1.90944 5.20447 1.781 5.25017 1.66343 5.29549C1.52323 5.34954 1.41748 5.50492 1.41748 5.65693V9.49463C1.41748 9.64559 1.52255 9.80111 1.66186 9.85632C2.73979 10.2835 3.87428 10.5 5.03382 10.5C6.19336 10.5 7.32785 10.2834 8.40583 9.85627C8.5451 9.80107 8.65011 9.64559 8.65011 9.49463V5.65693C8.65011 5.50492 8.54438 5.34954 8.40411 5.29544C8.28649 5.25012 8.15807 5.20442 8.00004 5.15168C7.9817 5.14556 7.95827 5.11357 7.95827 5.09459V3.42438C7.95819 1.81187 6.64635 0.5 5.03384 0.5ZM4.23729 6.82576C4.23729 6.38553 4.59392 6.02929 5.03379 6.02929C5.47362 6.02929 5.83025 6.3855 5.83025 6.82576C5.83025 7.11747 5.66575 7.36169 5.43201 7.50014V8.81697C5.43201 9.03711 5.25389 9.2152 5.03377 9.2152C4.81363 9.2152 4.63553 9.03711 4.63553 8.81697V7.50014C4.40181 7.36169 4.23729 7.11747 4.23729 6.82576ZM6.95269 3.42438V4.86548C6.32343 4.73007 5.67786 4.6615 5.03409 4.66145C4.39062 4.66145 3.74518 4.73004 3.11495 4.86532V3.42438C3.11495 2.36631 3.97573 1.50555 5.03379 1.50555C6.09183 1.50553 6.95269 2.36631 6.95269 3.42438Z"
                    fill="#525257"
                />
            </g>
            <defs>
                <clipPath id="clip0_4713_444">
                    <rect
                        width="10"
                        height="10"
                        fill="white"
                        transform="translate(0.0336914 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
